import PostRequestTimer from 'goog:yext.users.PostRequestTimer';

export function init() {
  var container = document.querySelector('.js-link-container');
  if (container != null) {
    ReactDOM.render(
      React.createElement(
        PostRequestTimer,
        {
          text: container.getAttribute('data-click-text'),
          postClickText: container.getAttribute('data-post-click-text'),
          duration: 15,
          url: '/users/sendEmailVerification',
        },
        null,
      ),
      container,
    );
  }
}
